export default __webpack_public_path__ + "static/media/logo_topo.05e94a9c.svg";